import { MenuItem } from "@mui/material";
import * as React from "react";

import { useAnalytics } from "@/providers";
import { FileRecord } from "@/shared/domain/files";
import { OpenInNewIcon } from "@/shared/foundation/icons/mui";
import { LoggerService } from "@/shared/services/LoggerService";

import { useGetFileContents } from "../hooks";

import styles from "./MenuItemError.module.css";

interface OpenFileInNewTabProps {
  fileRecord: FileRecord;
  onClick: () => void;
}

export function OpenFileInNewTab({
  fileRecord,
  onClick,
}: OpenFileInNewTabProps) {
  const getFileContentsAsUrl = useGetFileContents();
  const { trackEvent } = useAnalytics();

  const [error, setError] = React.useState<string | null>(null);

  const openFile = () => {
    getFileContentsAsUrl(fileRecord)
      .then((signedUrl: URL) => {
        trackEvent("FileOpenInNewWindowClicked", {
          fileId: fileRecord.file_id,
        });
        window.open(signedUrl, "_blank", "noopener,noreferrer");
        onClick();
      })
      .catch((error: unknown) => {
        LoggerService.error("Failed to open file in new tab", error);
        setError("Failed to open file. Try again.");
      });
  };

  return (
    <>
      <MenuItem onClick={openFile}>
        <OpenInNewIcon fontSize="small" />
        Open file in new tab
      </MenuItem>
      <div className={styles.errorText}>{error}</div>
    </>
  );
}
